import { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { FaHandsHelping, FaUserShield } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import styles from "./styles/user_management.module.scss";

// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row } from "react-bootstrap";
import AgentApplication from "./Components/AgentApplication.js";
import AgentManagement from "./Components/AgentManagement.js";
import BuyerManagement from "./Components/BuyerManagement.js";
import CustomTabs from "./Components/CustomTabs.js";
import Header from "./Components/Header.js";
import TabContent from "./Components/TabContent.js";
import MainCard from "../../Components/Cards/MainCard.js";

const UserManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);

  const dummyDataAgentApplication = [
    {
      id: 1,
      name: "Michael Thompson",
      email: "michael@example.com",
      status: "Pending",
      experience: "5 years",
      license: "FL-RE-12345",
      background: "Completed",
      submitDate: "3/9/2024",
    },
    {
      id: 2,
      name: "Sarah Connor",
      email: "sarah@example.com",
      status: "Approved",
      experience: "8 years",
      license: "TX-RE-98765",
      background: "Completed",
      submitDate: "4/10/2024",
    },
    {
      id: 3,
      name: "John Doe",
      email: "john@example.com",
      status: "Pending",
      experience: "3 years",
      license: "CA-RE-55555",
      background: "In Progress",
      submitDate: "2/15/2024",
    },
  ];

  const dummyDataAgentManagement = [
    {
      id: 1,
      name: "John Doe",
      brokerage: "Evergreen Estates",
      status: "ACTIVE",
      startDate: "2023-01-10",
    },
    {
      id: 2,
      name: "Jane Smith",
      brokerage: "BlueRock Realty",
      status: "PAUSED",
      startDate: "2023-01-15",
    },
    {
      id: 3,
      name: "Michael Brown",
      brokerage: "Prime Urban Group",
      status: "ACTIVE",
      startDate: "2023-01-20",
    },
    {
      id: 4,
      name: "Emily Taylor",
      brokerage: "Maple Leaf Homes",
      status: "SUSPENDED",
      startDate: "2023-02-05",
    },
    {
      id: 5,
      name: "Christopher White",
      brokerage: "Horizon Property Co.",
      status: "ACTIVE",
      startDate: "2023-02-12",
    },
    {
      id: 6,
      name: "Sophia Martinez",
      brokerage: "Sunrise Brokers",
      status: "PAUSED",
      startDate: "2023-02-18",
    },
    {
      id: 7,
      name: "David Thompson",
      brokerage: "Nova Nest Realty",
      status: "ACTIVE",
      startDate: "2023-03-01",
    },
    {
      id: 8,
      name: "Olivia Roberts",
      brokerage: "Oak & Stone Realty",
      status: "ACTIVE",
      startDate: "2023-03-10",
    },
  ];

  const dummyDataBuyer = [
    {
      id: 1,
      name: "John Doe",
      brokerage: "Evergreen Estates",
      status: "ACTIVE",
      startDate: "2023-01-10",
    },
    {
      id: 2,
      name: "Jane Smith",
      brokerage: "BlueRock Realty",
      status: "PAUSED",
      startDate: "2023-01-15",
    },
    {
      id: 3,
      name: "Michael Brown",
      brokerage: "Prime Urban Group",
      status: "ACTIVE",
      startDate: "2023-01-20",
    },
    {
      id: 4,
      name: "Emily Taylor",
      brokerage: "Maple Leaf Homes",
      status: "SUSPENDED",
      startDate: "2023-02-05",
    },
    {
      id: 5,
      name: "Christopher White",
      brokerage: "Horizon Property Co.",
      status: "ACTIVE",
      startDate: "2023-02-12",
    },
    {
      id: 6,
      name: "Sophia Martinez",
      brokerage: "Sunrise Brokers",
      status: "PAUSED",
      startDate: "2023-02-18",
    },
    {
      id: 7,
      name: "David Thompson",
      brokerage: "Nova Nest Realty",
      status: "ACTIVE",
      startDate: "2023-03-01",
    },
    {
      id: 8,
      name: "Olivia Roberts",
      brokerage: "Oak & Stone Realty",
      status: "ACTIVE",
      startDate: "2023-03-10",
    },
  ];

  const [activeKey, setActiveKey] = useState("agents");

  const tabs = [
    { key: "agents", label: "Agent Management", icon: <FaUserShield /> },
    {
      key: "buyers",
      label: "Buyer/Seller Management",
      icon: <FaHandsHelping />,
    },
    { key: "applications", label: "Agent Applications", icon: <FiFileText /> },
  ];

  // const content = {
  //   agents: <AgentManagement />,
  //   buyers: <BuyerManagement />,
  //   applications: <AgentApplication />,
  // };

  const content = (key) => {
    switch (key) {
      case "agents":
        return <AgentManagement data={dummyDataAgentManagement} />;
      case "buyers":
        return <BuyerManagement data={dummyDataBuyer} />;
      case "applications":
        return <AgentApplication data={dummyDataAgentApplication} />;
      default:
        return null;
    }
  };

  // const { data, isSuccess, isLoading, isFetching, refetch } =
  //   useGetAllUsersQuery(
  //     {
  //       search: searchQuery.length >= 3 ? searchQuery : "",
  //       limit: pageSize,
  //       page: currentPage,
  //       ...(status && status === "all"
  //         ? { is_blocked: "" }
  //         : { is_blocked: status === undefined ? "" : status }),
  //     },
  //     { refetchOnMountOrArgChange: true }
  //   );

  // useEffect(() => {
  //   if (data) {
  //     console.log(data);
  //     setPageSize(data.links.per_page);
  //     setCurrentPage(data.links.current);
  //     setTotalRecords(data.links.total_records);
  //     setTotalPages(data.links.total);
  //     setRowData(data.data);
  //     setDataFetched(true);

  //     if (data.data.length === 0) {
  //       setIndicationMessage("Data not available");
  //     }
  //   }
  // }, [data]);

  // const handleSendCoinModalOpen = () => {
  //   setSendCoinModal(true);
  // };

  // const handleSendCoinModalClose = () => {
  //   setSendCoinModal(false);
  //   setEditedData("");
  // };

  // const handleDeleteModalOpen = () => {
  //   setDeleteModal(true);
  // };

  return (
    <div className={styles.MainContainer}>
      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <Header
              title={"User Management"}
              subTitle={
                "Manage agents, clients, applications and user statuses "
              }
            />
          </Col>

          <Col md={6}>
            {/* <div className="d-flex justify-content-end align-items-center gap-2">
              <Input
                placeholder="Search by name"
                value={searchQuery}
                onChange={handleSearchChange}
              />

              <Controller
                control={control}
                name="status"
                render={({ field: { onChange, value } }) => (
                  <SelectFieldComponent
                    firstOption={_.isEmpty(value) ? "Select Status" : value}
                    optionsList={filterData}
                    onSelectChange={onChange}
                  />
                )}
              />
            </div> */}
          </Col>
        </Row>
      </div>
      <br></br>
      {/* TABS */}
      <CustomTabs
        tabs={tabs}
        activeKey={activeKey}
        onSelect={(key) => setActiveKey(key)}
      />
      {/* TAB CONTENT */}
      <div className="h-100 w-100">
        <TabContent activeKey={activeKey} content={content} />
      </div>
    </div>
  );
};

export default UserManagementScreen;
